import { useState, useMemo, useEffect, useRef } from 'react';
import VirtualizedMemberList from './VirtualizedMemberList';
import LoadingSpinner from '../common/LoadingSpinner';
import { performanceMonitor } from '../../utils/performanceMonitor';

function PerformantMemberList({ 
    members, 
    loading, 
    config, 
    onMemberHover, 
    onMemberHoverOut, 
    registerMemberList,
    isFavorite,
    onToggleFavorite,
    isPendingFavorite,
    isLoggedIn = true,
    enableVirtualization = true, // Allow toggling for comparison
    performanceMode = 'auto', // 'auto', 'virtualized', 'standard'
    showResultCount = false,
    totalMembers,
    sortBy,
    onSortChange,
    sortOptions,
    viewMode,
    onViewModeChange,
    defaultSort = 'joined'
}) {
    const [useVirtualization, setUseVirtualization] = useState(enableVirtualization);
    const [showPerformanceToggle, setShowPerformanceToggle] = useState(false);
    const memberCount = members?.length || 0;

    // Auto-decide on virtualization based on member count and performance mode
    useEffect(() => {
setUseVirtualization(true);
    }, [memberCount, performanceMode, enableVirtualization, config]);

    // Show performance toggle in development or when debug is enabled
    useEffect(() => {
        const isDevelopment = process.env.NODE_ENV === 'development';
        const hasDebugParam = window.location.search.includes('debug=performance');
        setShowPerformanceToggle(isDevelopment || hasDebugParam);
    }, []);

    // Monitor performance
    useEffect(() => {
        performanceMonitor.trackMemory('MemberList_Mount');
        performanceMonitor.monitorDOMNodes('MemberList_Mount');
    }, []);

    useEffect(() => {
        performanceMonitor.startTiming('MemberList_DataUpdate');
        performanceMonitor.endTiming('MemberList_DataUpdate');
        performanceMonitor.trackMemory('MemberList_DataUpdate');
    }, [members]);

    const handleToggleVirtualization = () => {
        performanceMonitor.startTiming('VirtualizationToggle');
        setUseVirtualization(!useVirtualization);
        performanceMonitor.endTiming('VirtualizationToggle');
        performanceMonitor.trackMemory('VirtualizationToggle');
    };

    // Render performance indicator
    const renderPerformanceInfo = () => {
        return null;

        
    };


        return (
            <div style={{ position: 'relative' }}>
                {renderPerformanceInfo()}
                <VirtualizedMemberList
                    members={members}
                    loading={loading}
                    config={config}
                    onMemberHover={onMemberHover}
                    onMemberHoverOut={onMemberHoverOut}
                    registerMemberList={registerMemberList}
                    isFavorite={isFavorite}
                    onToggleFavorite={onToggleFavorite}
                    isPendingFavorite={isPendingFavorite}
                    isLoggedIn={isLoggedIn}
                    showResultCount={showResultCount}
                    totalMembers={totalMembers}
                    sortBy={sortBy}
                    onSortChange={onSortChange}
                    sortOptions={sortOptions}
                    viewMode={viewMode}
                    onViewModeChange={onViewModeChange}
                    defaultSort={defaultSort}
                    onViewModeChange={onViewModeChange}
                />
            </div>
        );
}

export default PerformantMemberList;
